
import type { SDEScrapingParameters } from './types';
import { async_urls } from './descriptors/async_urls';
import { async_llm_urls } from './descriptors/async_llm_urls';

import { async_amazon_offer } from './descriptors/async_amazon_offer';
import { async_amazon_search } from './descriptors/async_amazon_search';
import { async_amazon_prices } from './descriptors/async_amazon_prices';
import { async_amazon_product } from './descriptors/async_amazon_product';
import { async_amazon_review } from './descriptors/async_amazon_review';

import { async_google_jobs } from './descriptors/async_google_jobs';
import { async_google_news } from './descriptors/async_google_news';
import { async_google_search } from './descriptors/async_google_search';
import { async_google_maps_search } from './descriptors/async_google_maps_search';
import { async_google_shopping } from './descriptors/async_google_shopping';

import { async_walmart_category } from './descriptors/async_walmart_category';
import { async_walmart_product } from './descriptors/async_walmart_product';
import { async_walmart_review } from './descriptors/async_walmart_review';
import { async_walmart_search } from './descriptors/async_walmart_search';

import { async_ebay_product } from './descriptors/async_ebay_product';
import { async_ebay_search } from './descriptors/async_ebay_search';

import { async_redfin_forsale } from './descriptors/async_redfin_for_sale';
import { async_redfin_forrent } from './descriptors/async_redfin_for_rent';
import { async_redfin_search } from './descriptors/async_redfin_search';
import { async_redfin_agent } from './descriptors/async_redfin_agent';

export const THE_BIG_DESCRIPTOR: SDEScrapingParameters[] = [
  // URL ---------------------------------
  async_urls,
  async_llm_urls,
  
  // AMAZON ---------------------------------
  async_amazon_product,
  async_amazon_prices,
  async_amazon_offer,
  async_amazon_search,
  async_amazon_review,

  // GOOGLE ---------------------------------
  async_google_jobs,
  async_google_maps_search,
  async_google_news,
  async_google_search,
  async_google_shopping,

  // WALMART ---------------------------------
  async_walmart_category,
  async_walmart_product,
  async_walmart_review,
  async_walmart_search,

  // EBAY ---------------------------------
  async_ebay_product,
  async_ebay_search,
  
  // REDFIN ---------------------------------
  async_redfin_forsale,
  async_redfin_forrent,
  async_redfin_search,
  async_redfin_agent
];
